"use client";

import { BadmintonScoreEditor } from "./badminton-score-editor";
import { BasketballScoreEditor } from "./basketball-score-editor";
import { CricketScoreEditor } from "./cricket-score-editor";
import { FootballScoreEditor } from "./football-score-editor";
import { PadelScoreEditor } from "./padel-score-editor";
import { PickleballScoreEditor } from "./pickleball-score-editor";
import { SnookerScoreEditor } from "./snooker-score-editor";
import { SquashScoreEditor } from "./squash-score-editor";
import { TableTennisScoreEditor } from "./table-tennis-score-editor";
import { TennisScoreEditor } from "./tennis-score-editor";
import { ThrowballScoreEditor } from "./throwball-score-editor";
import { VolleyballScoreEditor } from "./volleyball-score-editor";

const normalizeActivityId = (activityId: string) =>
  activityId
    .toLowerCase()
    .replace(/[^a-z-]/g, "")
    .replace(/-/g, "");

export type ActivityScoreEditorProps = {
  activityId: string;
  initialData?: Record<string, unknown> | null;
  onChange: (data: Record<string, unknown>) => void;
  maxDetailCount?: number;
};

export function ActivityScoreEditor({
  activityId,
  initialData,
  onChange,
  maxDetailCount,
}: ActivityScoreEditorProps) {
  const normalizedId = normalizeActivityId(activityId);

  switch (normalizedId) {
    case "tennis":
      return (
        <TennisScoreEditor
          initialData={initialData}
          onChange={onChange}
          maxDetailCount={maxDetailCount}
        />
      );
    case "badminton":
      return (
        <BadmintonScoreEditor
          initialData={initialData}
          onChange={onChange}
          maxDetailCount={maxDetailCount}
        />
      );
    case "tabletennis":
      return (
        <TableTennisScoreEditor
          initialData={initialData}
          onChange={onChange}
          maxDetailCount={maxDetailCount}
        />
      );
    case "squash":
      return (
        <SquashScoreEditor
          initialData={initialData}
          onChange={onChange}
          maxDetailCount={maxDetailCount}
        />
      );
    case "padel":
      return (
        <PadelScoreEditor
          initialData={initialData}
          onChange={onChange}
          maxDetailCount={maxDetailCount}
        />
      );
    case "pickleball":
      return (
        <PickleballScoreEditor
          initialData={initialData}
          onChange={onChange}
          maxDetailCount={maxDetailCount}
        />
      );
    case "snooker":
      return (
        <SnookerScoreEditor
          initialData={initialData}
          onChange={onChange}
          maxDetailCount={maxDetailCount}
        />
      );
    case "basketball":
      return (
        <BasketballScoreEditor initialData={initialData} onChange={onChange} />
      );
    case "football":
      return (
        <FootballScoreEditor initialData={initialData} onChange={onChange} />
      );
    case "volleyball":
      return (
        <VolleyballScoreEditor
          initialData={initialData}
          onChange={onChange}
          maxDetailCount={maxDetailCount}
        />
      );
    case "throwball":
      return (
        <ThrowballScoreEditor
          initialData={initialData}
          onChange={onChange}
          maxDetailCount={maxDetailCount}
        />
      );
    case "cricket":
      return (
        <CricketScoreEditor initialData={initialData} onChange={onChange} />
      );
    default:
      return null;
  }
}
